import React from 'react';
import { Banner } from '../../../components';



const HomeBanner = () => {

  return (

    <Banner 
      title="Find Your Perfect Ride Today" 
      subTitle="Drive Your Dream Car" 
      buttonText1="Browse Cars" 
      buttonLink1="Car-Grid" 
      buttonText2="Sell Your Car" 
      buttonLink2="SellCar"
    />

  );
}

export default HomeBanner;